import { FieldArray } from 'react-final-form-arrays';

import { REQUIRED_ERROR } from 'CorePackage/MainModule/constants/validationErrors';
import { Hint } from 'CorePackage/MainModule/components/Hint';
import { makeRequired } from 'CorePackage/MainModule/validators/isRequired';
import { FieldBlock } from 'UIPackage/FormModule/components/FieldBlock';
import { Row } from 'UIPackage/FormModule/components/Row';
import { Button } from 'UIPackage/MainModule/components/Button';
import { CloseButton } from 'UIPackage/MainModule/components/CloseButton';
import { ISelectOption } from 'UIPackage/MainModule/components/SelectInput';
import { SelectInputField } from 'UIPackage/MainModule/components/SelectInputField';

import { getPrescriptionOptionsForRow, LINK_PRESCRIPTIONS_FIELD, TPrescriptionRow } from '../functions/prescriptions';
import styles from './LinkPrescriptions.module.scss';

const NO_PRESCRIPTIONS_MESSAGE = 'Данных не найдено';

const getNotAppliedChangesMessage = (linkFieldLabel: string) =>
  `Для применения изменений нажмите на кнопку “Сохранить” в поле “${linkFieldLabel}”`;

const validatePrescription = makeRequired(REQUIRED_ERROR);

interface ILinkPrescriptionsProps {
  options: ISelectOption[];
  /**
   * Поле редактируемое. Если подходящее предписание одно, оно подставлено автоматически
   * и менять его нельзя.
   */
  isEditable: boolean;
  isCurrentRaid: boolean;
  /** Предписания изменили после последнего сохранения */
  isChanged: boolean;
  linkFieldLabel: string;
  watchOnly: boolean;
}

/**
 * Поле "Предписание" для ссылки на паспорт рейдового осмотра при повторной проверке предписания.
 */
export const LinkPrescriptions = ({
  options,
  isEditable,
  isCurrentRaid,
  isChanged,
  linkFieldLabel,
  watchOnly,
}: ILinkPrescriptionsProps) => (
  <FieldArray name={LINK_PRESCRIPTIONS_FIELD}>
    {({ fields }) => {
      const rows: TPrescriptionRow[] = fields.value ?? [];

      if (!rows.length) return null;

      return (
        <FieldBlock
          label="Предписание"
          color="black"
          margin="top"
          button={
            <Button
              className="shared-btn-add"
              text="Добавить"
              type="button"
              variant="link"
              color="primary"
              id="addPrescriptionButton"
              disabled={watchOnly || !isCurrentRaid || rows.length >= options.length}
              onClick={() => fields.push(undefined)}
            />
          }
        >
          <Row>
            {fields.map((name, index) => (
              <div className={styles.PrescriptionRow} key={name}>
                <SelectInputField
                  className={styles.PrescriptionSelect}
                  id={`linkPrescription-${index}`}
                  name={name}
                  options={getPrescriptionOptionsForRow(options, rows, index)}
                  placeholder="Выберите предписание"
                  noOptionsMessage={NO_PRESCRIPTIONS_MESSAGE}
                  validate={validatePrescription}
                  disabled={watchOnly || !isEditable}
                  isSearchable={false}
                  size="medium"
                />
                {isEditable && rows.length > 1 && (
                  <CloseButton
                    className="shared-deleting-row-btn"
                    disabled={watchOnly}
                    onClick={() => fields.remove(index)}
                  />
                )}
              </div>
            ))}
          </Row>
          {isChanged && <Hint text={getNotAppliedChangesMessage(linkFieldLabel)} />}
        </FieldBlock>
      );
    }}
  </FieldArray>
);
